import React, {Fragment} from 'react';
import Navbar from '../nav-bar/nav-bar';
import laptopIcon from '../../assets/box_blue.png';
import warehouseIcon from '../../assets/warehouse-icon_blue.png';
import printerIcon from '../../assets/printer-icon.png';
import './about-us.scss';

export default function () {
    return (
        <Fragment>
            <div id={'about-us'}>
                <Navbar/>
                <div className={'about-us-content'}>
                    <h2>About Us</h2>
                    <p>ShipsLand is web application which gives services to e-commerce marketplace
                        sellers. Our application enables e-commerce marketplace sellers to manage all
                        their orders from all platforms just in one screen and easily create shipping
                        labels for your orders. Our application takes care of all the boring details and
                        give you a simple and clean work environment to handle all your orders. We are
                        taking our business to the next level and working on our fulfillment center
                        project. Our fulfillment center will give services with warehouses in Turkey, United States
                        and China. Inventory management will be accessed through our web app. We will
                        store your products for your with real time data that you can check from our web
                        app and when there is an order, we will handle it for you. Founded on 2020 in
                        Istanbul/Turkey and Massachusets/United States . Our company aims to satisfy all users with quick and
                        easy solutions and always try to take ourselves to the next level.</p>
                    <br/>
                    <div>
                        <p>
                            <b>Our Service</b>
                        </p>
                        <div className={'service-list'}>
                            <div className={'m_4'}>
                                <img alt={'laptopIcon'} className={'service-icon'} src={laptopIcon}/>
                                <p>Logistic</p>
                            </div>
                            <div className={'m_4'}>
                                <img alt={'warehouseIcon'} className={'service-icon'} src={warehouseIcon}/>
                                <p>Warehouse</p>
                            </div>
                            <div className={'m_4'}>
                                <img alt={'printerIcon'} className={'service-icon'} src={printerIcon}/>
                                <p>fulfillment</p>
                            </div>
                        </div>
                        <br/>
                    </div>
                    <div>
                        <p>
                            <b>Contact Us</b>
                        </p>
                        <br/>
                        <div>
                            <div className={'flex flex-row center'}>
                                <i class="fas fa-envelope fa-2x dark-blue-icon contact-icon"></i>
                                <p><a href="mailto:support@shipsland.com" style={{textDecoration:'none'}}>support@shipsland.com</a></p>
                            </div>
                            <div className={'flex flex-row center'}>
                                <i className="fas fa-phone-alt fa-2x dark-blue-icon contact-icon"></i>
                                <p>+1-413-513-9008</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )

}